import { Component, OnInit, Input, Output, EventEmitter, OnChanges,
  SimpleChange, SimpleChanges, Inject  } from '@angular/core';
import { ConfigurateurRubrique, Constantes, RenderCanvas } from "app/model/configurateur";
import { DomSanitizer} from '@angular/platform-browser';
import * as jsPDF from 'jspdf';

@Component({
  selector: 'app-rubriques',
  templateUrl: './rubriques.component.html',
  styleUrls: ['./rubriques.component.css']

})
export class RubriquesComponent implements OnInit, OnChanges {

  @Input() Rubriques:ConfigurateurRubrique[];
  @Input() renderCanvas:RenderCanvas;
  @Output() PrintDevis = new EventEmitter<RenderCanvas>();
  @Output() SelectRubrique = new EventEmitter<ConfigurateurRubrique>();
  @Output() CancelConfiguration = new EventEmitter<boolean>();
  
  constructor(private sanitizer:DomSanitizer) { }

  ngOnInit() {
  }

ngOnChanges(changes: {[propKey:string] : SimpleChange}){ // {[propKey:string] : SimpleChange} or SimpleChanges

    // this.facade = this.renderCanvas.facade;

    // if (this.renderCanvas.modele != null) {
    //   this.design = this.Data.designs.find(d => d.code == this.renderCanvas.modele.codeDesign);
    //   this.materiau =  this.Data.materiaux.find(m => m.code == this.renderCanvas.modele.codeMateriau);
    //   this.modele = this.Data.modeles.find(m => m.code == this.renderCanvas.modele.codeModele);
    //   this.couleur = this.Data.couleurs.find(m => m.code == this.renderCanvas.modele.codeCouleur);
    // }
    //console.log('compute rubrique : ');
  }

  onClickRubrique(rubrique: ConfigurateurRubrique) {
    
    if (! rubrique.disable) {
      console.log('onClickRubrique send rubrique : ' + (rubrique != null ? rubrique.code : 'not init'));
      if (rubrique.code.toLowerCase() == Constantes.NOUVEAU.toLowerCase()) {
        if(confirm("Voulez-vous charger un nouveau projet ? (votre ancien projet ne sera pas sauvegardé)")) {
          this.CancelConfiguration.emit(true);
        }
        
      }
      else if (rubrique.code.toLowerCase() == Constantes.DOCUMENT_PDF.toLowerCase()) {
        this.PrintDevis.emit(this.renderCanvas);
      }
      else {
        this.SelectRubrique.emit(rubrique);
      }
    }
   
  }

  getRubriques() {
    return (this.Rubriques != null  ? this.Rubriques : null);
  }

  getRubriqueCssClass(rubrique: ConfigurateurRubrique) {
    return (rubrique != null && rubrique.disable ? "rubrique-disable" : "rubrique-enable");
  }

  

       
}


// WEBPACK FOOTER //
// ./src/app/creator/rubriques/rubriques.component.ts